import { Trans } from '@lingui/react';
import { NavStepper } from '../../../../../components/steppers/nav-stepper/NavStepper';
import { NavStepperStep } from '../../../../../components/steppers/nav-stepper/NavStepperStep';
import { SnrBasedStepDuration } from './StepDuration';
import { SnrBasedStepStrikePrice } from './StepStrikePrice';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { SnrBasedStepParticipants } from './StepParticipants';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Alert } from '@startuptools/ui/Alert';
import { useWarrantProgramSuspenseQuery, WarrantProgramDocument } from '../../../WarrantProgram.graphql';
import { useApolloClient } from '@apollo/client';

export const SnrBasedWarrantStepper = ({ warrantProgramId }: { warrantProgramId: string }) => {
  const companyId = useCompanyId();
  const apollo = useApolloClient();
  const {
    data: { warrantProgram, warrantProgramErrors },
  } = useWarrantProgramSuspenseQuery({ variables: { companyId, warrantProgramId, getWpErrors: true } });

  return (
    <Stack gap={3}>
      <Typography level="h3">
        {warrantProgram.name && (
          <>
            {warrantProgram.name}
            {' - '}
          </>
        )}
        {warrantProgram.description}
      </Typography>

      <Alert variant="outlined">
        <Trans id="This options program was made outside of Bolago. Fill in the missing information to keep track of it better." />
      </Alert>

      <NavStepper path="*" onStepSaved={() => apollo.refetchQueries({ include: [WarrantProgramDocument] })}>
        <NavStepperStep
          label={<Trans id="Duration" />}
          path="duration"
          validatorStatus={warrantProgramErrors!.duration}
        >
          <SnrBasedStepDuration warrantProgram={warrantProgram} />
        </NavStepperStep>
        <NavStepperStep
          label={<Trans id="Strike Price" />}
          path="strike-price"
          validatorStatus={warrantProgramErrors!.strikePrice}
        >
          <SnrBasedStepStrikePrice warrantProgram={warrantProgram} />
        </NavStepperStep>
        <NavStepperStep
          label={<Trans id="Participants" />}
          path="participants"
          validatorStatus={warrantProgram.optionsRegistrations[0]!.validatorErrors.participants}
        >
          <SnrBasedStepParticipants warrantProgram={warrantProgram} />
        </NavStepperStep>
      </NavStepper>
    </Stack>
  );
};
